/* ============================================================
   c_ajax-pagination.js — ページ遷移なしのページネーション
   [data-ajax-pagination] を持つセクション内の .c-pagination のリンクを
   Shopify Section Rendering API で取得して差し替える。
   [data-ajax-link] のリンク（タグのタブ）も同じ扱い。セクション内に [data-ajax-region] が
   あれば、グリッドだけでなくその範囲（タブの選択状態・絞り込みの件数を含む）を丸ごと差し替える。
   JS 無効時・クローラーは通常のリンク遷移にフォールバックする（プログレッシブエンハンスメント）。
   ============================================================ */
(function () {
  if (window.__cAjaxPagination) return;
  window.__cAjaxPagination = true;

  var ROOT_SEL = '[data-ajax-pagination]';
  var GRID_SEL = '.c-fprod__row--wrap';
  var NAV_SEL = '.c-pagination';
  var REGION_SEL = '[data-ajax-region]';
  var LINK_SEL = '.c-pagination__link[href], [data-ajax-link][href]';

  /* fetch 用 URL に section_id を付与 */
  function sectionUrl(href, sectionId) {
    var u = new URL(href, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    u.hash = '';
    return u.toString();
  }

  /* sticky ヘッダー分を差し引いてセクション先頭にスクロール */
  function scrollToRoot(root) {
    var header = document.querySelector('.c-header-wrap');
    var offset = header ? header.getBoundingClientRect().height : 0;
    var top = root.getBoundingClientRect().top + window.pageYOffset - offset - 10;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
  }

  /* 戻る/進むで差し替え直せるよう、履歴にどのセクションの状態かを残す。
     最初のページの履歴にも印を付けておき、そこへ戻ったときも差し替え直す */
  function pushHistory(sectionId, href) {
    var st = window.history.state;
    if (!st || !st.cAjaxPagination) {
      window.history.replaceState({ cAjaxPagination: true, sectionId: sectionId }, '', window.location.href);
    }
    window.history.pushState({ cAjaxPagination: true, sectionId: sectionId }, '', href);
  }

  function currentUrl() {
    return window.location.pathname + window.location.search;
  }

  function load(root, href, push, fromTab, fromPop) {
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;

    /* 連続クリック時は最後の操作だけを反映する（先の応答が後から届いて上書きしないように） */
    if (root.__cAjaxAbort) root.__cAjaxAbort.abort();
    var ctrl = window.AbortController ? new AbortController() : null;
    root.__cAjaxAbort = ctrl;
    var seq = (root.__cAjaxSeq || 0) + 1;
    root.__cAjaxSeq = seq;
    /* 読み込み中は「表示中の URL」を未確定にする。戻る→進むを素早く押したとき、
       古い応答が届く前の popstate を「同じ URL」と誤ってスキップしないため */
    var reqUrl = href.split('#')[0];
    root.__cAjaxUrl = null;

    var grid = root.querySelector(GRID_SEL);
    if (grid) grid.setAttribute('aria-busy', 'true');
    root.classList.add('is-loading');

    fetch(sectionUrl(href, sectionId), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (seq !== root.__cAjaxSeq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var curRegion = root.querySelector(REGION_SEL);
        var newRegion = doc.querySelector(REGION_SEL);
        if (curRegion && newRegion) {
          /* 絞り込みのボタン（c_facets）は閉じた状態で描き直す。開いたまま差し替えると選択肢が商品に重なるため */
          var hadFocus = curRegion.contains(document.activeElement);
          curRegion.replaceWith(newRegion);
          root.__cAjaxUrl = reqUrl;
          if (push) pushHistory(sectionId, href);
          /* 押したリンクごと差し替わりフォーカスが消えるので、行き先を明示する */
          var current = fromTab ? newRegion.querySelector('[data-ajax-link][aria-current="page"]') : null;
          if (fromPop) {
            /* 戻る/進むはブラウザのスクロール復元に任せる。フォーカスが中にあったときだけ戻す */
            if (hadFocus) newRegion.focus({ preventScroll: true });
          } else if (current) {
            current.focus({ preventScroll: true });
          } else {
            scrollToRoot(root);
            newRegion.focus({ preventScroll: true });
          }
          return;
        }

        var newGrid = doc.querySelector(GRID_SEL);
        var newNav = doc.querySelector(NAV_SEL);
        var curGrid = root.querySelector(GRID_SEL);
        var curNav = root.querySelector(NAV_SEL);
        if (!newGrid || !curGrid) throw new Error('grid not found');

        curGrid.replaceWith(newGrid);
        if (curNav && newNav) curNav.replaceWith(newNav);
        else if (curNav) curNav.remove();
        root.__cAjaxUrl = reqUrl;

        if (push) pushHistory(sectionId, href);
        if (!fromPop) scrollToRoot(root);
      })
      .catch(function (err) {
        /* 新しい操作で取り消した分は何もしない。それ以外の失敗は通常遷移にフォールバック */
        if ((err && err.name === 'AbortError') || seq !== root.__cAjaxSeq) return;
        window.location.href = href;
      })
      .then(function () {
        if (seq !== root.__cAjaxSeq) return;
        root.classList.remove('is-loading');
        var g = root.querySelector(GRID_SEL);
        if (g) g.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var target = e.target;
    if (!target || !target.closest) return;
    var link = target.closest(LINK_SEL);
    if (!link) return;
    var root = link.closest(ROOT_SEL);
    if (!root) return;
    e.preventDefault();
    load(root, link.getAttribute('href'), true, link.hasAttribute('data-ajax-link'));
  });

  /* ブラウザの戻る/進む。このスクリプトが積んだ履歴だけを扱う（#アンカーへの移動などは無視） */
  window.addEventListener('popstate', function (e) {
    var st = e.state;
    if (!st || !st.cAjaxPagination || !st.sectionId) return;
    var root = document.querySelector(ROOT_SEL + '[data-section-id="' + st.sectionId + '"]');
    if (!root) return;
    /* アンカー移動から戻っただけなど、表示中と同じ URL なら取り直さない */
    if (root.__cAjaxUrl && root.__cAjaxUrl === currentUrl()) return;
    load(root, currentUrl(), false, false, true);
  });
})();
